import './Badge.css';

/**
 * Match confidence tier badge — the canonical 3 tiers from
 * docs/platform/08-information-architecture.md §6.1. API values are
 * lowercase snake_case; UI labels are the documented persona-language names.
 * Colour semantics (Green/Amber/Gray) are fixed by that doc and implemented
 * via the tier-* token group (own group, never aliased to status —
 * docs/design-system/themes.md §5).
 */
export type MatchTier = 'auto_merge' | 'review' | 'ignore';

const TIER_LABEL: Record<MatchTier, string> = {
  auto_merge: 'Auto-merge',
  review: 'Review',
  ignore: 'Ignore',
};

const TIER_VARIANT_CLASS: Record<MatchTier, string> = {
  auto_merge: 'dpr-badge--tier-auto',
  review: 'dpr-badge--tier-review',
  ignore: 'dpr-badge--tier-ignore',
};

export function TierBadge({ tier }: { tier: MatchTier }) {
  return (
    <span className={`dpr-badge ${TIER_VARIANT_CLASS[tier]}`} data-tier={tier}>
      {TIER_LABEL[tier]}
    </span>
  );
}
